// dev
// export const ENDPOINT_URL = 'http://localhost:8080';

// prod S3 storate
export const ENDPOINT_URL = "https://api.h-creations.com/api";
export const IMG_URL = `https://d33h8icwcso2tj.cloudfront.net`;

export const IMG_UPLOAD_PATH = "uploads";
// `${ENDPOINT_URL}/${IMG_UPLOAD_PATH}/`,
